import * as React from "react";
import { useId } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRocket = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 640 640",
		fill: "currentColor",
		...props,
		children: /* @__PURE__ */ _jsx("path", { d: "M524.7 96.5C534.2 98.4 541.6 105.8 543.5 115.3C552.5 160.3 558.2 229.3 523.8 296C503.1 336 469 373.3 416 403.7L416 484.8C416 501.7 407.2 517.3 392.7 526L304.5 578.9C283.2 591.7 256 576.3 256 551.5L256 448C256 412.7 227.3 384 192 384L88.5 384C63.6 384 48.3 356.9 61.1 335.5L114 247.3C122.7 232.8 138.3 224 155.2 224L236.3 224C266.7 170.9 304 136.8 344 116.2C410.7 81.7 479.7 87.5 524.7 96.5zM304 448.7L304 523.2L368 484.8L368 427C348.6 435 327.3 442.2 304 448.6zM481.2 274C504.9 228.1 505 179.4 499.3 140.8C460.7 135 412 135.2 366.1 158.9C318.3 183.6 269 236.2 238.4 346.1C263 357.3 282.9 377.1 294.1 401.8C404 371.2 456.6 321.9 481.3 274.1zM213 272L155.2 272L116.8 336L191.3 336C197.7 312.7 204.9 291.4 212.9 272zM400 200C422.1 200 440 217.9 440 240C440 262.1 422.1 280 400 280C377.9 280 360 262.1 360 240C360 217.9 377.9 200 400 200z" })
	});
};
export default SvgRocket;
